import { RestrictedAccountObjectStoreFacade } from "../restricted-account-object/restricted-account-object.store-facade";
import { Observable } from "rxjs/Observable";
import { Transition } from "./transition.model";
import { Qry } from "../query-facade";
import * as actions from "./transition.actions";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import { DefaultTask } from "../default-task/default-task.model";
import { isInArray } from "../../../core/util/is-in-array";
import { removeFromArray } from "../../../core/util/remove-from-array";
import { intersect } from "../../../core/util/utils";

export class TransitionStoreFacade extends RestrictedAccountObjectStoreFacade<Transition> {

    getAll(): Observable<Array<Transition>> {
        return this.select(Qry.getInstance().transition.byActiveAccount);
    }

    create(transition: Transition): void {
        this.submit(transition);
    }

    update(transition: Transition): void {
        this.submit(transition);
    }

    protected submit(transition: Transition): void {

        let defaultTasks: Array<DefaultTask> = [];
        this.appFacade.objects.defaultTask.store.getAll()
            .take(1)
            .subscribe(_defaultTasks => defaultTasks = _defaultTasks);

        // ensure the transition does not contain any ides that do not exist (yet)
        transition = new Transition({
            ...transition,
            defaultTasks: intersect(transition.defaultTasks, defaultTasks.map(defaultTask => defaultTask.id))
        });

        // save the transition
        this.dispatch(new actions.SubmitAction(transition));

        // ensure the transition's id is added to all defaultTasks that it references
        defaultTasks
            .filter(defaultTask => isInArray(defaultTask.id, transition.defaultTasks))
            .forEach(defaultTask => {
                this.appFacade.objects.defaultTask.store.attachTransition(defaultTask, transition);
            });

        // remove the transition's id from all defaultTasks it does not reference
        defaultTasks
            .filter(defaultTask => !isInArray(defaultTask.id, transition.defaultTasks))
            .forEach(defaultTask => {
                this.appFacade.objects.defaultTask.store.detachTransition(defaultTask, transition);
            });
    }

    insert(transition: Transition): void {
        this.dispatch(new actions.SubmitAction(transition, {persistable: true, restful: false}));
    }

    remove(transition: Transition, options?: ActionOptionsArgs): void {
        this.dispatch(new actions.RemoveAction(transition, options));
    }

    attachDefaultTask(transition: Transition, defaultTask: DefaultTask): void {

        if (isInArray(transition.id, defaultTask.transitions)) {
            return;
        }

        transition = new Transition({
            ...transition,
            defaultTasks: [...transition.defaultTasks, defaultTask.id]
        });

        this.dispatch(new actions.SubmitAction(transition));
    }

    detachDefaultTask(transition: Transition, defaultTask: DefaultTask): void {

        if (!isInArray(transition.id, defaultTask.transitions)) {
            return;
        }

        transition = new Transition({
            ...transition,
            defaultTasks: removeFromArray(transition.defaultTasks, defaultTask.id)
        });

        this.dispatch(new actions.SubmitAction(transition));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/transition/transition.store-facade.ts